export default "__VITE_ASSET__aNiVjVQS__"